import React from 'react';
import { Route, Switch, Redirect, HashRouter } from 'react-router-dom';
import { isAuthenticated } from './modulos/auth/auth';
import Login from './components/login/Login';
import RedefinirSenha from './components/redefinir-senha';
import RecuperarSenha from './components/recuperar-senha';
import CriarAcesso from './components/criar-acesso';
import Acesso from './components/acesso/Acesso';
import MeusDados from './components/meusDados';
import EditarPerfil from './components/editarPerfil';
import MeuLink from './components/meuLink';
import Home from './containers/home';

import Layout from './containers/layout';
import Vendas from './components/vendas';
import ListaContratos from './components/listaContratos';
import { ContratosAtraso } from './components/contratos-atraso';
import { ContratosEntregues } from './components/contratos-entregues';
import { ContratosRecebidos } from './components/contratos-recebidos';
import CadastrarContratos from './components/cadastrar-contratos';
import Pdf from './components/pdf';
import CadastrarDependentes from './components/cadastrar-dependentes';
import Assinatura from './components/assinatura';
import Pagamento from './components/pagamento/index';
import MensagemAbertura from './components/mensagem-abertura/index';
import graficoCompras from './components/graphsCompras/index';
import Avisos from './components/avisos/index';
import TabelaPreco from './components/tabelaPreco/index.jsx';
import TabelaEdicaoPreco from './components/tabelaEdicaoPreco/index';
import ExibeAssinaturas from './components/exibeAssinaturas/index';
import Ajuda from './components/ajuda/index.jsx';
import CadastrarDocumentos from './components/cadastrarDocumentos/index.jsx';
import CobrancaAssociado from './components/cobranca-associado';
import CadastroEdicaoPrecos from './components/cadastro-edicao-precos-lote';
import RegularPagamentos from './components/regular-pagamento';
import RegularPagamentosBloqueados from './components/regular-pagamentos-bloqueados';
import CadastrarServicosAdicionais from './components/cadastrar-servicos-adicionais';
import { decriptObjectOnLocalStorage } from './modulos/cripotografia/criptoStorage';
import CadastroEdicaoPrecosMensalidadeLote from './components/cadastro-edicao-precos-mensalidade-lote';
import ListarUpSell from './components/upSell/index.js';
import Bonificacao from './components/tabelaEdicaoPreco/bonificacao';
import TelaComparativo from './components/upSell/TelaComparativo/index.js';

const permissao = decriptObjectOnLocalStorage('PERM');

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={props =>
            isAuthenticated() ? (
                <Component {...props} />
            ) : (
                <Redirect to={{
                    pathname: '/login',
                    state: { from: props.location }
                }} />
            )
        }
    />
);

const Routes = () => (
    <HashRouter>
        {
            <Switch>
                <Route exact path="/login" component={Login} />
                <Route exact path="/acesso" component={Acesso} />
                <Route exact path="/criar-acesso" component={CriarAcesso} />
                <Route exact path="/recuperar-senha" component={RecuperarSenha} />
                <Route exact path="/redefinir-senha/:key" component={RedefinirSenha} />
                <Route exact path="/meus-dados" component={MeusDados} />
                <Route exact path="/editar-perfil" component={EditarPerfil} />
                <Route exact path="/pdf" component={Pdf} />
                <Route
                    exact
                    path="/exibir-assinaturas/:key/:inscricao"
                    component={ExibeAssinaturas}
                />
                <Route exact path="/mensagem-abertura" component={MensagemAbertura} />
                permissao == 1 ? (
                <PrivateRoute exact path="/vendas" component={Vendas} />
                <PrivateRoute exact path="/" component={Home} />
                <PrivateRoute exact path="/graficos" component={graficoCompras} />
                <PrivateRoute exact path="/home" component={Home} />
                <PrivateRoute exact path="/app" component={() => <h1>logado</h1>} />
                <PrivateRoute exact path="/layout" component={Layout} />
                <PrivateRoute exact path="/meu-link" component={MeuLink} />
                <PrivateRoute exact path="/lista-contratos" component={ListaContratos} />
                <PrivateRoute exact path="/contratos-atraso" component={ContratosAtraso} />
                <PrivateRoute
                    exact
                    path="/contratos-entregues"
                    component={ContratosEntregues}
                />
                <PrivateRoute
                    exact
                    path="/contratos-recebidos"
                    component={ContratosRecebidos}
                />
                <PrivateRoute
                    exact
                    path="/cadastrar-contratos"
                    component={CadastrarContratos}
                />
                <PrivateRoute
                    exact
                    path="/cadastrar-dependentes/:inscricao"
                    component={CadastrarDependentes}
                />
                <PrivateRoute
                    exact
                    path="/cadastrar-documentos/:inscricao"
                    component={CadastrarDocumentos}
                />
                <PrivateRoute
                    exact
                    path="/cadastrar-servicos-adicionais/:inscricao"
                    component={CadastrarServicosAdicionais}
                />
                <PrivateRoute exact path="/assinatura/:inscricao" component={Assinatura} />
                <PrivateRoute exact path="/pagamento/:incricao" component={Pagamento} />
                <PrivateRoute exact path="/avisos" component={Avisos} />
                <PrivateRoute exact path="/tabela-Preco" component={TabelaPreco} />
                <Route exact path="/up-sell" component={ListarUpSell} />
                <Route exact path="/up-sell/comparativo/:inscricao" component={TelaComparativo} />
                <PrivateRoute exact path="/ajuda" component={Ajuda} />
                ) : permissao == 2 ? (
                <PrivateRoute exact path="/" component={graficoCompras} />
                <PrivateRoute exact path="/meus-dados" component={MeusDados} />
                <PrivateRoute exact path="/lista-contratos" component={ListaContratos} />
                <PrivateRoute exact path="/assinatura/:inscricao" component={Assinatura} />
                <PrivateRoute exact path="/ajuda" component={Ajuda} />
                ) : permissao == 3 ? (
                <PrivateRoute exact path="/" component={graficoCompras} />
                <PrivateRoute exact path="/meus-dados" component={MeusDados} />
                <PrivateRoute exact path="/lista-contratos" component={ListaContratos} />
                <PrivateRoute exact path="/assinatura/:inscricao" component={Assinatura} />
                <PrivateRoute exact path="/ajuda" component={Ajuda} />
                ) : (
                <PrivateRoute exact path="/" component={graficoCompras} />
                <PrivateRoute exact path="/meus-dados" component={MeusDados} />
                <PrivateRoute exact path="/lista-contratos" component={ListaContratos} />
                <PrivateRoute exact path="/assinatura/:inscricao" component={Assinatura} />
                <PrivateRoute exact path="/editar-tabela-preco" component={TabelaEdicaoPreco} />
                <PrivateRoute exact path="/bonificacao" component={Bonificacao} />
                <PrivateRoute exact path="/regular-pagamentos" component={RegularPagamentos} />
                <PrivateRoute
                    exact
                    path="/regular-pagamentos-bloqueados"
                    component={RegularPagamentosBloqueados}
                />
                <PrivateRoute exact path="/cobranca-assoc" component={CobrancaAssociado} />
                <PrivateRoute
                    exact
                    path="/cadastro-edicao-precos"
                    component={CadastroEdicaoPrecos}
                />
                <PrivateRoute
                    exact
                    path="/cadastro-edicao-precos-mensalidades"
                    component={CadastroEdicaoPrecosMensalidadeLote}
                />
                <PrivateRoute exact path="/ajuda" component={Ajuda} />)
            </Switch>
        }
    </HashRouter>
);

export default Routes;
